export default __webpack_public_path__ + "static/media/be-part-of-the-game.1b78bd97.svg";